










import { Component, Vue, Prop } from 'vue-property-decorator';

type IReminderInfo = IUser.IResponse.IUserDetailInfo;

@Component
export default class ReminderList extends Vue {
  @Prop({default: () => []}) private reminders!: IReminderInfo[];
  @Prop({default: () => ''}) private markName!: string;
  @Prop({default: () => ({display: 'inline-block'})}) private boxStyle!: any;
}
